enum Palette {
  BORDIER = 'bordier',
  VCFC = 'vcfc',
  DEFAULT = '',
}

export class PaletteUtils {
  static isBordierPalette = process.env.COLOR_PALLETE === Palette.BORDIER;
}
